import { configureStore } from "@reduxjs/toolkit";
// settings
import settings from "../features/settings/Slice";

// auth
import auth from "../features/auth/Slice";

// common
import common from "../features/admin/common/Slice";

// masters
import masters from "./masters";

// products
import products from "./products";

import orders from "./order";

import aboutus from "./aboutus";

import customers from "./customers";

import usermanagement from "./usermanagement";

import ReviewRating from "./reviewrating";

import property from "../features/admin/property/slice"

import subscription from "../features/admin/subscription/slice"

import room from "../features/admin/property/roomSlice"

import tenant from "../features/admin/property/tenantSlice";

import whatsapp from "./whatsapp";




export const store = configureStore({
  reducer: {
    // settings
    settings: settings,
    //auth
    auth: auth,
    //common
    common: common,
    //masters
    masters,
    //products
    products,
    //aboutus
    aboutus,
    //customers
    customers,

    orders,

    usermanagement,
    ReviewRating,

    property,
    tenant: tenant,
    room: room,
    subscription: subscription,
    whatsapp

  },
});
